export const text = {
  title: "Reset Password",
  resetDescription: "Create your new password.",
  newPassword: "New Password",
  newPasswordPlaceholder: "Enter new password",
  confirmPasswordPlaceholder: "Confirm new password",
  confirmPassword: "Confirm New Password",
  passwordContains: "Password contains",
  submit: "Reset",
  passwordContain: "Password contains:",
  letter: "At least 1 Capital  Letter.",
  number: "At least 1 Special  Character & 1 Number.",
  long: "6-15 characters long.",
};
